import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Shared imports array for common Angular modules
 * Use this in component imports arrays to avoid repeating common imports
 * 
 * Example usage:
 * ```typescript
 * @Component({
 *   imports: [...SHARED_IMPORTS, OtherComponent],
 * })
 * ```
 */
export const SHARED_IMPORTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslatePipe,
] as const;
